// extracted by mini-css-extract-plugin
export default {"container":"Likert7_container__o4u2r"};